<div class="input-group mb-3 d-none d-md-flex">
  <span class="input-group-text">
    <fa-icon icon="search"></fa-icon>
  </span>
  @if (($searchVal != '' && $searchVal != undefined)) {
    <div class="clear-search cursor-pointer"
      (click)="$searchVal = ''; startSearch()">
      <fa-icon icon="times"></fa-icon>
    </div>
  }
  <input [(ngModel)]="$searchVal" (ngModelChange)="startSearch()" type="text" class="form-control"
    placeholder="Rechercher par mot(s) clé(s)" aria-label="Rechercher par mot(s) clé(s)">
</div>
@if ($searchVal) {
  <div class="d-inline-block d-md-none pb-2">
    <div class="d-inline-block">
      <span class="d-flex mobile-search-info">
        {{ $searchVal }}
        <fa-icon class="d-block" icon="times" (click)="$searchVal = ''; startSearch()"></fa-icon>
      </span>
    </div>
    <span class="text-info">
      {{resultsCount}} résultat(s)
    </span>
  </div>
} @else {
  <div class="d-block d-md-none">
    <app-mobile-search (mobileSearch)="$searchVal = $event; startSearch()"></app-mobile-search>
  </div>

}
